'use client';

import { tsrShared } from '@/libs/ts-rest/ts-rest';
import { createIndustryChildrenQueryOptions } from '@/modules/shared/contracts';
import type { IndustryChildrenQueryOptions } from '@/modules/shared/contracts';

export const useIndustryChildrenQuery = (industryId?: string, options?: Partial<IndustryChildrenQueryOptions>) => {
	const queryOptions = createIndustryChildrenQueryOptions(industryId);

	return tsrShared.industries.listChildrenById.useQuery({
		...queryOptions,
		...options,
	});
};
